<template>
  <div class="pdv-bloqueio-page">
    <div class="pdv-bloqueio-card">
      <div class="pdv-bloqueio-icon">
        <i class="fas fa-ban"></i>
      </div>

      <h1>Operacao bloqueada no PDV</h1>
      <p class="pdv-bloqueio-desc">
        A empresa esta temporariamente sem permissao para operar no PDV Desktop.
      </p>

      <div class="pdv-bloqueio-info">
        <div class="pdv-bloqueio-line">
          <span class="pdv-bloqueio-label">Motivo:</span>
          <span>{{ motivoBloqueio }}</span>
        </div>
        <div class="pdv-bloqueio-line" v-if="codigoBloqueio">
          <span class="pdv-bloqueio-label">Codigo:</span>
          <span>{{ codigoBloqueio }}</span>
        </div>
      </div>

      <div class="pdv-bloqueio-actions">
        <button class="pdv-bloqueio-btn pdv-bloqueio-btn--primary" @click="revalidarStatus">
          <i class="fas fa-sync-alt"></i>
          Revalidar status
        </button>
        <button class="pdv-bloqueio-btn" @click="abrirConfiguracaoTerminal">
          <i class="fas fa-cog"></i>
          Configuracao do terminal
        </button>
      </div>

      <small class="pdv-bloqueio-help">
        Se o bloqueio persistir, entre em contato com o suporte para regularizacao da assinatura/plano.
      </small>
    </div>
  </div>
</template>

<script>
import TerminalConfigService from "@/modules/PdvDesktop/services/TerminalConfigService";

export default {
  name: "BloqueioSuporte",

  data() {
    return {
      codigoBloqueio: "",
      motivoBloqueio: "Empresa bloqueada para operacoes de PDV.",
      carregando: false,
    };
  },

  async mounted() {
    await this.carregarBloqueio();
  },

  methods: {
    async carregarBloqueio() {
      if (!this.$isDesktop || !this.$electron) return;
      try {
        const [code, motivo] = await Promise.all([
          this.$electron.config.get("terminal_code_bloqueio"),
          this.$electron.config.get("terminal_motivo_bloqueio"),
        ]);
        this.codigoBloqueio = code || "";
        if (motivo) this.motivoBloqueio = motivo;
      } catch (_) {
        // Mantem fallback local
      }
    },

    async revalidarStatus() {
      if (this.carregando) return;
      this.carregando = true;
      try {
        await TerminalConfigService.garantirTerminalAutorizado({ forcar: true });
        this.$toast && this.$toast.success("Acesso liberado. Redirecionando...");
        this.$router.push({ name: "pdvDesktopDashboard" });
      } catch (e) {
        this.codigoBloqueio = e.code || this.codigoBloqueio;
        this.motivoBloqueio = e.message || this.motivoBloqueio;
        this.$toast && this.$toast.error(this.motivoBloqueio);
      } finally {
        this.carregando = false;
      }
    },

    abrirConfiguracaoTerminal() {
      this.$router.push({ name: "pdvDesktopConfiguracaoTerminal" });
    },
  },
};
</script>

<style scoped>
.pdv-bloqueio-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 20% 20%, #fff4f1 0%, #ffe6e0 45%, #ffd2c8 100%);
  padding: 24px;
}

.pdv-bloqueio-card {
  width: min(640px, 100%);
  background: #ffffff;
  border: 1px solid #ffd0c6;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(154, 52, 18, 0.12);
  padding: 28px;
}

.pdv-bloqueio-icon {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #fff1ee;
  color: #c2410c;
  display: grid;
  place-items: center;
  font-size: 24px;
  margin-bottom: 14px;
}

h1 {
  margin: 0 0 8px;
  font-size: 25px;
  color: #7c2d12;
}

.pdv-bloqueio-desc {
  margin: 0 0 16px;
  color: #7f1d1d;
  font-size: 15px;
}

.pdv-bloqueio-info {
  border: 1px solid #fed7cc;
  border-radius: 10px;
  background: #fff8f6;
  padding: 12px;
}

.pdv-bloqueio-line {
  display: flex;
  gap: 8px;
  color: #7c2d12;
  font-size: 14px;
  line-height: 1.4;
}

.pdv-bloqueio-line + .pdv-bloqueio-line {
  margin-top: 6px;
}

.pdv-bloqueio-label {
  min-width: 62px;
  font-weight: 700;
}

.pdv-bloqueio-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.pdv-bloqueio-btn {
  border: 1px solid #f5b7a3;
  background: #fff;
  color: #9a3412;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.pdv-bloqueio-btn--primary {
  background: #ea580c;
  border-color: #ea580c;
  color: #fff;
}

.pdv-bloqueio-help {
  margin-top: 12px;
  display: block;
  color: #9a3412;
}
</style>
